/*
 * @Author: error: git config user.name && git config user.email & please set dead value or install git
 * @Date: 2022-04-21 17:27:16
 * @LastEditors: error: git config user.name && git config user.email & please set dead value or install git
 * @LastEditTime: 2022-08-03 14:45:52
 * @FilePath: \oweFront\src\store\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import {
  createStore
} from 'vuex'
export default createStore({
  state: {
    isLogin: false || Boolean(sessionStorage.getItem('isLogin')),
    // userInfo: sessionStorage.getItem('userInfo') ? JSON.parse(sessionStorage.getItem("userInfo")) : {},
    menuList: sessionStorage.getItem('menuList') ? JSON.parse(sessionStorage.getItem("menuList")) : [],
    tabsList: sessionStorage.getItem('tabsList') ? JSON.parse(sessionStorage.getItem("tabsList")) : [{
      text: "首页",
      id: "-1",
      attributes: { url: "adminIndex" },
    }],
	keeptabsList:[],
    tabsIndex: sessionStorage.getItem('tabsIndex') ? Number(sessionStorage.getItem("tabsIndex")) : 0,
  },
  mutations: {
    handleLogin: (state, isLogin) => {
      state.isLogin = isLogin
      sessionStorage.setItem('isLogin', isLogin)
    },
    setUserInfo: (state, userInfo) => {
      state.userInfo = userInfo
      sessionStorage.setItem('userInfo', JSON.stringify(userInfo))

    },
    handleMenuList: (state, menuList) => {
      state.menuList = menuList
      sessionStorage.setItem('menuList', JSON.stringify(menuList))
    },
    handleTabsList: (state, tabsList) => {
      if (tabsList.length <= 0) {
        const obj = {
          text: "首页",
          id: "-1",
          attributes: { url: "adminIndex" },
        };
        tabsList.push(obj)
      }
      state.tabsList = tabsList

      console.log(tabsList, 'tabsList')
      sessionStorage.setItem('tabsList', JSON.stringify(tabsList))
    },
    handleTabsIndex: (state, tabsIndex) => {
      state.tabsIndex = tabsIndex
      console.log(tabsIndex, 'tabsIndex')
      sessionStorage.setItem('tabsIndex', state.tabsIndex)
    }

  },
  actions: {},
  modules: {}
})